// StoreLocator.js
import React, { useEffect } from "react";

import bgImg from "../../assets/images/1920x1080-GRADIENT-BG.jpg";

const StoreLocator = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//cdn.storerocket.io/widget.js";
    script.onload = () => {
      if (window.StoreRocket) {
        window.StoreRocket.init({
          selector: ".storerocket-store-locator",
          account: "WPJmAVPJlv",
        });
      } else {
        console.error("StoreRocket initialization failed.");
      }
    };
    document.head.appendChild(script);

    // Cleanup function to remove the script when the component unmounts
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div
      className="main-padding bg-hmcGray-dark bg-cover bg-center"
      style={{ backgroundImage: `url(${bgImg})` }}
    >
      <div className="main-margin">
        <h1 className="sub-header text-white mb-10">Asset Map</h1>
        <div className="storerocket-store-locator"></div>
      </div>
    </div>
  );
};

export default StoreLocator;
